import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import SimpleDate from "../../../modules/SimpleDate";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleMonthYearPicker, {convertToDateObject} from "../../../modules/SimpleMonthYearPicker";
import Api from "../../../Services/Api";
import POFixTable from "./poFixTable";
import PoTent1Table from "./poTent1Table";
import PoTent2Table from "./poTent2Table";
import {Status} from "../../common/Constants";
import moment from "moment";
import "moment/locale/id";
import { fetchDataAsync } from "../../../Services/Utils";
import { saveAs } from "file-saver";

moment.locale("id");
class PoUnitDetail extends Component {
    constructor(props) {
        super(props);
        this.aksi = this.props.state.detail?.aksi
        this.state = {
            poNo: "",
            confirmDelete: false,
            poMonthValue: "",
            submitAlertInformation: null,
            printVisible: false,
            loading: false,
            mainDealerName: "",
            changeFix: false,
            changeTent1: false,
            changeTent2: false,
            data: this.props.data ? this.props.data : null,
            successDelete: false,
            alertPOUnitExist: false,
        };
    }

    async componentDidMount() {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        if (this.props.state.detail.poNo) {
            try {
                const response = await Api.create("NAGAMAS_TRANSACTION").getPOUnitById(
                this.props.state.detail.poNo
            );
            
            if (response.ok) {
                const monthValue = convertToDateObject(response.data.data?.poMonth);
                this.setState((prevValue) => ({
                    ...prevValue,
                    poMonthValue: monthValue,
                    poNo: response.data.data?.poNo,
                    mainDealerName: response.data.data.cabangAndSupplier?.supplier.supplierName,
                    data: {
                        ...response.data.data,
                        kodeSupplierMD: response.data.data.cabangAndSupplier?.supplier.supplierCode,
                        poFix: response.data.data.poUnitFixTen?.fix,
                        tentative1: response.data.data.poUnitFixTen?.tent1,
                        tentative2: response.data.data.poUnitFixTen?.tent2,
                    },
                }));
            }
            } catch (error) {
                console.log(error);
            }
        } else {
            const responses = await Promise.all([
                Api.create("NAGAMAS_MASTER_DATA").getAllMasterSupplier({
                    jenisSupplier: "SPL03",
                    cabang: [this.props.state.kodeCabang.value],
                    status: Status.ACTIVE,
                }),
                Api.create("NAGAMAS_MASTER_DATA").generateSeqWithoutSave({
                    seqType: "POUnit",
                    nosDealerCode: this.props.state.kodeCabang.value,
                    transactionType: "POUnit",
                }),
            ]);

            responses.forEach((response, idx) => {
                if (response.ok) {
                    if (idx === 0) {
                        this.setState((prevValue) => ({
                            ...prevValue,
                            mainDealerName: response.data.data ? response.data?.data?.at(0)?.supplierName : "",
                            data: {
                                ...prevValue.data,
                                kodeSupplierMD: response.data?.data?.at(0)?.supplierCode
                            }
                        }));
                    } else {
                        this.setState((prevValue) => ({
                            ...prevValue,
                            poNo: response.data,
                        }));
                    }
                }
            });
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    }

    componentDidUpdate = async (prevProps, prevState, snapshot) => {
        let prevListPoFix = prevState.data?.poFix;
        let prevListTent1 = prevState.data?.tentative1;
        let prevListTent2 = prevState.data?.tentative2;
        let currListPoFix = this.state.data?.poFix;
        let currListTent1 = this.state.data?.tentative1;
        let currListTent2 = this.state.data?.tentative2;
        let index = null;
        let indexQty = null;
        let indexM2 = null;
        let index1 = null;
        let indexQty1 = null;
        let index2 = null;

        let listProyeksiSalesMtd = await currListPoFix?.forEach((item, idx) => {
            const prevItem = prevListPoFix?.[idx];
            if (prevItem && item.proyeksiSalesMtd !== prevItem.proyeksiSalesMtd) {
                index = idx;
            }
        })

        let listProyeksiSalesM2 = await currListPoFix?.forEach((item, idx) => {
            const prevItem = prevListPoFix?.[idx];
            if (prevItem && item.proyeksiSalesM2 !== prevItem.proyeksiSalesM2) {
                indexM2 = idx;
            }
        })

        let listQtyPoReal = await currListPoFix?.forEach((item, idx) => {
            const prevItem = prevListPoFix?.[idx];
            if (prevItem && item.qtyPoReal !== prevItem.qtyPoReal) {
                indexQty = idx;
            }
        })

        let listSalesTentative1 = await currListTent1?.forEach((item, idx) => {
            const prevItem = prevListTent1?.[idx];
            if (prevItem && (item.targetSalesTentative1 !== prevItem.targetSalesTentative1)) {
                index1 = idx;
            }
        });

        let listQtyTentative1Real = currListTent1?.forEach((item, idx) => {
            const prevItem = prevListTent1?.[idx];
            if (prevItem && item.qtyPoTentative1Real !== prevItem.qtyPoTentative1Real) {
                indexQty1 = idx;
            }
        });

        let listSalesTentative2 = currListTent2?.forEach((item, idx) => {
            const prevItem = prevListTent2?.[idx];
            if (prevItem && item.targetSalesTentative2 !== prevItem.targetSalesTentative2) {
                index2 = idx;
            }
        });

        if (!R.isNil(index2)) {
            let dataPoFix = currListPoFix?.[index2];
            let dataTent1 = currListTent1?.[index2];
            let dataTent2 = currListTent2?.[index2];
            this.setState((prevValue) => ({
                ...prevValue,
                data: {
                    ...prevValue.data,
                    tentative2: prevValue.data.tentative2.map((item, idx) => {
                        if (idx === index2) return this.handleChangeTargetSalesTentative2(dataPoFix, dataTent1, dataTent2);
                        else return item;
                    })
                }
            }));
        } else if (!R.isNil(index1) || !R.isNil(indexQty1)) {
            console.log(index1, indexQty1)
            let indexes = R.isNil(index1) ? indexQty1 : index1;
            let dataPoFix = currListPoFix?.[indexes];
            let dataTent1 = currListTent1?.[indexes];
            let dataTent2 = currListTent2?.[indexes];
            let tent1 = dataTent1;
            if (R.isNil(indexQty1)) tent1 = this.handleChangeTargetSalesTentative1(dataPoFix, dataTent1);
            this.setState((prevValue) => ({
                ...prevValue,
                data: {
                    ...prevValue.data,
                    tentative1: prevValue.data.tentative1.map((item, idx) => {
                        if (idx === indexes) return tent1;
                        else return item;
                    }),
                    tentative2: prevValue.data.tentative2.map((item, idx) => {
                        if (idx === indexes) return this.handleChangeQtyTent1Real(dataPoFix, tent1, dataTent2);
                        else return item;
                    })
                }
            }));
        } else if (!R.isNil(index) || !R.isNil(indexQty) || !R.isNil(indexM2)) {
            let indexes = R.isNil(index) ? R.isNil(indexQty) ? indexM2 : indexQty : index;
            let dataPoFix = currListPoFix?.[indexes];
            let dataTent1 = currListTent1?.[indexes];
            let dataTent2 = currListTent2?.[indexes];
            let poFix = dataPoFix;
            if (!R.isNil(index)) poFix = this.handleChangeSales(dataPoFix);
            else if (!R.isNil(indexM2)) poFix = this.handleChangeSalesM2(dataPoFix);
            let tent1 = this.handleChangeQtyPoReal(poFix, dataTent1);
            this.setState((prevValue) => ({
                ...prevValue,
                data: {
                    ...prevValue.data,
                    poFix: prevValue.data.poFix.map((item, idx) => {
                        if (idx === indexes) return poFix;
                        else return item;
                    }),
                    tentative1: prevValue.data.tentative1.map((item, idx) => {
                        if (idx === indexes) return tent1;
                        else return item;
                    }),
                    tentative2: prevValue.data.tentative2.map((item, idx) => {
                        if (idx === indexes) return this.handleChangeQtyTent1Real(dataPoFix, tent1, dataTent2);
                        else return item;
                    })
                }
            }));
        }
    };

    handleChangeSales = (dataPoFix) => {
        dataPoFix.currentStockM2 = dataPoFix.unitExisting + dataPoFix.poRealBefore - dataPoFix.proyeksiSalesMtd || 0;
        return {
            ...dataPoFix,
            ...this.handleChangeSalesM2(dataPoFix),
        }
    };

    handleChangeSalesM2 = (dataPoFix) => {
        console.log("changeSalesM2")
        let stockDays = parseFloat(((dataPoFix.currentStockM2 - dataPoFix.proyeksiSalesM2) / dataPoFix.meanSalesOneYear).toFixed(1)) || 0;
        let delta = dataPoFix.acuanStock - stockDays || 0;
        let qtyPoRecommended = Math.ceil(delta * dataPoFix.meanSalesOneYear) || 0;
        return {
            ...dataPoFix,
            stockDays: stockDays,
            delta: delta,
            qtyPoRecommended: qtyPoRecommended,
            qtyPoReal: qtyPoRecommended,
        }
    };

    handleChangeQtyPoReal = (dataPoFix, dataTent1) => {
        dataTent1.sisaStokAfterFix = dataPoFix.currentStockM2 - dataPoFix.proyeksiSalesM2 + dataPoFix.qtyPoReal || 0;
        dataTent1.targetSalesTentative1 = dataTent1.sisaStokAfterFix || 0;
        return {
            ...dataTent1,
            ...this.handleChangeTargetSalesTentative1(dataPoFix, dataTent1),
        }
    };

    handleChangeTargetSalesTentative1 = (dataPoFix, dataTent1) => {
        let salesDayTentative1 = parseFloat((dataTent1.targetSalesTentative1 / 25).toFixed(1)) || 0;
        let sisaStokTentative1 = dataTent1.sisaStokAfterFix - dataTent1.targetSalesTentative1 || 0;
        let stockDayTentative1 = Math.ceil(dataTent1.sisaStokTentative1 / salesDayTentative1) || 0;
        let delta = dataPoFix.acuanStock - stockDayTentative1 || 0;
        let qtyPoTentative1Recommended = Math.trunc(delta * salesDayTentative1) || 0;
        return {
            ...dataTent1,
            salesDayTentative1: salesDayTentative1,
            sisaStokTentative1: sisaStokTentative1,
            stockDayTentative1: stockDayTentative1,
            delta: delta,
            qtyPoTentative1Recommended: qtyPoTentative1Recommended,
            qtyPoTentative1Real: qtyPoTentative1Recommended,
        }
    };

    handleChangeQtyTent1Real = (dataPoFix, dataTent1, dataTent2) => {
        dataTent2.sisaStokAfterTentative1 = dataTent1.sisaStokAfterFix - dataTent1.targetSalesTentative1 + dataTent1.qtyPoTentative1Real || 0;
        dataTent2.targetSalesTentative2 = dataTent2.sisaStokAfterTentative1 || 0;
        return {
            ...dataTent2,
            ...this.handleChangeTargetSalesTentative2(dataPoFix, dataTent1, dataTent2),
        }
    };

    handleChangeTargetSalesTentative2 = (dataPoFix, dataTent1, dataTent2) => {
        let salesDayTentative2 = parseFloat((dataTent2.targetSalesTentative2 / 25).toFixed(1)) || 0;
        let sisaStokTentative2 = dataTent2.sisaStokAfterTentative1 - dataTent2.targetSalesTentative2 || 0;
        let stockDayTentative2 = Math.ceil(dataTent2.sisaStokAfterTentative1 / salesDayTentative2) || 0;
        let delta = dataPoFix.acuanStock - stockDayTentative2 || 0;
        let qtyTentative2Recommended = parseInt(delta * salesDayTentative2) || 0;
        return {
            ...dataTent2,
            salesDayTentative2: salesDayTentative2,
            sisaStokTentative2: sisaStokTentative2,
            stockDayTentative2: stockDayTentative2,
            delta: delta,
            qtyTentative2Recommended: qtyTentative2Recommended,
            qtyTentative2Real: qtyTentative2Recommended,
        }
    };

    handleValueChange = (dataName, index, key, value) => {
        const intValue = parseInt(value);
        this.setState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                [dataName]: prevValue.data[dataName].map((val, idx) =>
                    idx === index ? {...val, [key]: isNaN(intValue) ? 0 : intValue} : val
                ),
            },
        }));
    };

    checkPOUnitExist = async () => {
        try {
            const res = await Api.create("NAGAMAS_TRANSACTION").checkPOUnitExist({
                poMonth: this.state.poMonthValue.format("MMMM YYYY"),
                kodeCabang: this.props.state.kodeCabang?.value,
            });
            return res?.data?.data;
        } catch (error) {
            return false
        }
    }

    handleSubmit = async () => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const data = this.state.data;
        const isAlreadyExist = await this.checkPOUnitExist();
        
        if(isAlreadyExist && !this.props.state.detail.poNo){
            this.handleAlertPOUnitExistVisibility()
            this.setState({ loading: false });
            return
        }
        const request = {
            poNo: data.poNo,
            poDate: data.poDate,
            kodeSupplierMD: data.kodeSupplierMD,
            kodeCabang: data.kodeCabang,
            poMonth: data.poMonth,
            poFix: data.poFix.map((f) => ({
                ...f,
                qtyPoReal: this.getNumberValue(f.qtyPoReal),
            })),
            tentative1: data.tentative1.map((t) => ({
                ...t,
                targetSalesTentative1: this.getNumberValue(t.targetSalesTentative1),
                qtyPoTentative1Real: this.getNumberValue(t.qtyPoTentative1Real),
            })),
            tentative2: data.tentative2.map((t) => ({
                ...t,
                targetSalesTentative2: this.getNumberValue(t.targetSalesTentative2),
                qtyTentative2Real: this.getNumberValue(t.qtyTentative2Real),
            })),
        };

        const isTableFixValid = !R.isEmpty(request.poFix)
            ? request.poFix.every((f) => f.qtyPoReal !== "")
            : true;
        const isTableTent1Valid = !R.isEmpty(request.tentative1)
            ? request.tentative1.every(
                (t) => t.targetSalesTentative1 !== "" && t.qtyPoTentative1Real !== ""
            )
            : true;
        const isTableTent2Valid = !R.isEmpty(request.tentative2)
            ? request.tentative2.every(
                (t) => t.targetSalesTentative2 !== "" && t.qtyTentative2Real !== ""
            )
            : true;

        if (!request.poMonth || !isTableFixValid || !isTableTent1Valid || !isTableTent2Valid) {
            this.setState((prevValue) => ({
                ...prevValue,
                submitAlertInformation: {
                    error: true,
                    content: <p>Ada Qty yang belum terisi. Harap dilengkapi sebelum disimpan.</p>,
                },
            }));
            return;
        }

        try {
            await Api.create("NAGAMAS_TRANSACTION").createPOUnit(request);
        } catch (error) {
            // TODO
        }

        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
            submitAlertInformation: {
                error: false,
                content: <p>Data PO unit berhasil disimpan.</p>,
            },
        }));
    };

    handleShowConfirmationDelete = () => {
        this.setState((prevValue) => ({...prevValue, confirmDelete: !prevValue.confirmDelete}));
    };
    
    handleSuccessDeleteVisibility = () => {
        this.setState((prevValue) => ({...prevValue, successDelete: !prevValue.successDelete}));
    };

    handleAlertPOUnitExistVisibility = () => {
        this.setState((prevValue) => ({...prevValue, alertPOUnitExist: !prevValue.alertPOUnitExist}));
    };  

    handleSubmitDelete = async () => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        try {
            await Api.create("NAGAMAS_TRANSACTION").deletePOUnit(this.state.poNo);
        } catch (error) {
            // TODO
        }
        this.setState((prevValue) => ({...prevValue, loading: false, confirmDelete: false, successDelete: true}));
    };

    handleDoneSubmit = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            submitAlertInformation: null,
        }));
    };

    handlePrint = async () => {
        this.setState({ loading: true })
        const result = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION_FILE").exportPOUnitDetailToExcel,
            setError: this.props.setError,
            menuName: "PO Unit Detail",
            args:{
                poNo: this.state.poNo
            }
        })
        if(result.ok){
            const blob = new Blob([result.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
            saveAs(blob, 'PO_UNIT.xlsx')
        }
        this.setState({ loading: false })
    };

    getNumberValue = (value) => parseInt(value) || (parseInt(value) === 0 ? 0 : "");

    handleMonthChange = async (value) => {
        this.setState((prevValue) => ({...prevValue, poMonthValue: value, loading: true}));
        const response = await Api.create("NAGAMAS_TRANSACTION").getTempPOUnit(
            this.props.state.detail.cabang.value,
            value.format("MMMM YYYY")
        );

        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                data: response.data.data
                    ? {...response.data.data, poMonth: value.format("MMMM YYYY"), ...prevValue.data}
                    : null,
            }));
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    getButton = () => {
      switch (this.aksi) {
        case 'edit':
        case 'create':
          return <SimpleButton onClick={this.handleSubmit}>SIMPAN</SimpleButton>;

        case 'preview':
          return <SimpleButton onClick={this.handlePrint}>Cetak PO</SimpleButton>;

        case 'delete':
          return (
            <SimpleButton
              onClick={this.handleShowConfirmationDelete}
              disabled={!this.state.poNo || !this.props.isCanDelete}
            >
              HAPUS
            </SimpleButton>
          );

        default:
          return null;
      }
    };


    render() {
        return (
            <>
                <SimpleModal
                    title="PO Detail"
                    visible={this.props.state.detail.visible}
                    onClickClose={()=>this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <div
                                className="grid grid-3x grid-mobile-none gap-15px"
                                style={{alignItems: "center"}}
                            >
                                <SimpleInput
                                    id="input_text_no_po"
                                    name="noPO"
                                    label="No. PO"
                                    readOnly
                                    value={this.state.poNo}
                                />
                                <SimpleDate
                                    id="select_date_tanggal"
                                    name="noPO"
                                    label="Tanggal"
                                    disabled
                                    date={this.state.data?.poDate || new Date()}
                                />
                                <SimpleInput
                                    id="input_text_main_dealer_name"
                                    name="kodeSupplierMD"
                                    label="Main Dealer Name"
                                    readOnly
                                    value={this.state.mainDealerName}
                                />
                            </div>
                            <div
                                className="grid grid-3x grid-mobile-none gap-15px"
                                style={{alignItems: "center"}}
                            >
                                <div/>
                                <SimpleMonthYearPicker
                                    id="select_date_month_year"
                                    label="PO Month"
                                    mandatory
                                    readOnly={this.props.state.detail.poNo}
                                    value={this.state.poMonthValue}
                                    minDate={new Date()}
                                    onChange={this.handleMonthChange}
                                />
                                <SimpleDDL
                                    id="select_options_dealer_cabang"
                                    name="dealerCabang"
                                    label="Dealer Cabang"
                                    box="search"
                                    readOnly
                                    value={this.props.state.detail.cabang}
                                />
                            </div>
                            <Tabs>
                                <TabList>
                                    <Tab>PO Fix</Tab>
                                    <Tab>PO Tent 1</Tab>
                                    <Tab>PO Tent 2</Tab>
                                </TabList>
                                <TabPanel>
                                    <POFixTable
                                        data={this.state.data?.poFix}
                                        onValueChange={this.handleValueChange}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <PoTent1Table
                                        data={this.state.data?.tentative1}
                                        onValueChange={this.handleValueChange}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <PoTent2Table
                                        data={this.state.data?.tentative2}
                                        onValueChange={this.handleValueChange}
                                    />
                                </TabPanel>
                            </Tabs>
                            <FlexView hAlignContent="right" className="margin-top-15px">
                                {this.getButton()}
                            </FlexView>
                        </ModalContainer>
                    }
                />
                {this.state.confirmDelete && (
                    <SimpleAlert
                        title="Konfirmasi"
                        visible={this.state.confirmDelete}
                        onClickClose={this.handleShowConfirmationDelete}
                        content={
                            <div>
                                <p>Anda yakin hendak menghapus data PO unit ini ?</p>
                                <br/>
                                <FlexView hAlignContent="center">
                                    <SimpleButton secondary onClick={this.handleShowConfirmationDelete}>
                                        Batal
                                    </SimpleButton>
                                    <SimpleButton onClick={this.handleSubmitDelete}>Ya</SimpleButton>
                                </FlexView>
                            </div>
                        }
                    />
                )}
                {this.state.successDelete && (
                  <SimpleAlert
                    title="Informasi"
                    visible={this.state.successDelete}
                    onClickClose={this.handleSuccessDeleteVisibility}
                    content={
                      <div>
                        <p>Data Berhasil Dihapus</p>
                        <br />
                        <FlexView hAlignContent="center">
                          <SimpleButton
                            onClick={() => {
                              this.props.onClickClose(true);
                              this.handleSuccessDeleteVisibility();
                            }}
                          >
                            OK
                          </SimpleButton>
                        </FlexView>
                      </div>
                    }
                  />
                )}
                {this.state.submitAlertInformation && (
                    <SimpleAlert
                        visible={!!this.state.submitAlertInformation}
                        onClickClose={this.handleDoneSubmit}
                        title="PO Unit"
                        content={
                            <div>
                                {this.state.submitAlertInformation.content}
                                <br/>
                                <SimpleButton 
                                    onClick={()=> {
                                        this.props.onClickClose(true);
                                        this.handleDoneSubmit()
                                    }}
                                >OK</SimpleButton>
                            </div>
                        }
                    />
                )}
                {this.state.alertPOUnitExist && (
                    <SimpleAlert
                        visible={this.state.alertPOUnitExist}
                        onClickClose={this.handleAlertPOUnitExistVisibility}
                        title="Peringatan"
                        content={
                            <div>
                                <p>PO tidak dapat dibuat pada periode bulan yang sama!</p>
                                <br/>
                                <SimpleButton 
                                    onClick={()=> {
                                        this.handleAlertPOUnitExistVisibility()
                                    }}
                                >
                                    OK
                                </SimpleButton>
                            </div>
                        }
                    />)
                }
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
                {this.state.printVisible && <SimplePrintTable onClearPrint={this.handlePrint}/>}
            </>
        );
    }
}

export default PoUnitDetail;
